import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      'Our experts will now take care of all the steps.' +
      '\n\n' +
      'Your client account holder will receive an e-mail inviting him/her to create his/her account to finalise the opening',
    info: 'You will be able to open a second file as soon as your personal documents are validated',
    next: 'Understood!',
    title: 'And that’s it!',
  },
  fr: {
    description:
      'Nos expert·es vont désormais s’occuper de toutes les démarches.' +
      '\n\n' +
      'Votre client·e titulaire du compte va recevoir un e-mail l’invitant à créer son compte pour finaliser l’ouverture.',
    info: 'Vous pourrez ouvrir un second dossier dès que vos documents personnels seront validés.',
    next: 'C’est compris\u00A0!',
    title: 'Et voilà\u00A0!',
  },
} as const);

export default locales;
